define('lib/leaflet-wms-get-feature-info/leaflet-wms-get-feature-info',['leaflet', 'lib/leaflet-wms-get-feature-info/response-formatter'], function(
  responseFormatter
) {
  'use strict';

  L.Control.WmsGetFeatureInfo = L.Control.extend({
    // default options
    options: {
      layers: [],
      title: 'GetFeatureInfo',
      version: '1.3.0',
      desiredFormats: ['application/json', 'application/geojson', 'text/plain'],
      crs: L.CRS.EPSG3857,
    },

    initialize: function(options) {
      L.Util.setOptions(this, options || {});
    },

    onAdd: function(map) {
      this._map = map;
      this._map.on('singleclick', this._handleMapClick.bind(this));

      // do initial GetCapabilities for all unique WMS services
      this._uniqueWmsServiceUrls = getUniqueWmsServiceUrls(this.options.layers);
      this._wmsServiceConfigs = {};
      fetchAndSetAvailableFormats(
        this.options,
        this._uniqueWmsServiceUrls,
        this._wmsServiceConfigs
      );

      return L.DomUtil.create('div'); // need to return a HTML element
    },

    _handleMapClick: function(event) {
      if (event.originalEvent.target.tagName.toLowerCase() === 'button') return;

      var wmsLayersInMap = [];
      this._map.eachLayer(function(layer) {
        if (layer._url) {
          wmsLayersInMap.push(layer);
        }
      });

      var self = this;
      var popupOutput = '';
      var numberOfIterations = 0;

      this._uniqueWmsServiceUrls.forEach(function(wmsServiceUrl) {
        var layersMatchingWmsUrl = self.options.layers
          .filter(function(layer) {
            var layerExistsInAvailableLayers = wmsLayersInMap.find(function(wmsLayer) {
              return stripQueryStrings(wmsLayer._url) === stripQueryStrings(layer.wmslayer.baseurl);
            });
            var layerMatchesWmsServiceUrl =
              layer.wmslayer.baseurl.substring(0, wmsServiceUrl.length) === wmsServiceUrl;
            return layerExistsInAvailableLayers && layerMatchesWmsServiceUrl;
          })
          .map(function(layer) {
            return layer.wmslayer.layer;
          });

        if (!layersMatchingWmsUrl.length) {
          numberOfIterations++;
          return;
        }

        var format = getDesiredFormatForWmsService(
          self.options.desiredFormats,
          self._wmsServiceConfigs[wmsServiceUrl].formats
        );

        var getFeatureInfoUrlRequest = {
          map: self._map,
          baseUrl: wmsServiceUrl,
          version: self._wmsServiceConfigs[wmsServiceUrl].version,
          format: format,
          layerNames: layersMatchingWmsUrl,
          x: event.containerPoint.x,
          y: event.containerPoint.y,
        };
        performWmsRequest(getFeatureInfoUrl(self.options, getFeatureInfoUrlRequest), function(
          response
        ) {
          numberOfIterations++;
          // service returns xml if an error occurred, in that case, do not try to format response
          var xmlFormatSelected = format === 'application/xml' || format === 'text/xml';
          if (response.responseText.startsWith('<?xml') && !xmlFormatSelected) {
            return;
          }
          popupOutput += formatGetFeatureInfoResponse(response.responseText, format);

          if (getFeatureInfoUrlRequest.format === 'text/plain') {
            popupOutput += '<br><br>';
          }

          // all unique wmsServiceUrls have been iterated, add popup to map
          if (numberOfIterations >= self._uniqueWmsServiceUrls.length && popupOutput.length) {
            addPopupToMap(self._map, event.latlng, popupOutput);
          }
        });
      });
    },
  });

  return L.Control.WmsGetFeatureInfo;

  /*
  HELPER FUNCTIONS
  */
  function addPopupToMap(map, latlng, content) {
    L.popup({ maxWidth: 600 })
      .setLatLng(latlng)
      .setContent('<div style="font-size: 14px">' + content + '</div>')
      .openOn(map);
  }

  function formatGetFeatureInfoResponse(content, format) {
    var output;

    if (format === 'application/json') {
      output = responseFormatter.formatJson(content);
    } else if (format === 'text/plain') {
      output = truncate(responseFormatter.formatPlainText(content), 1200);
    } else if (format === 'text/html') {
      output = responseFormatter.formatHtml(content);
    }
    return output || '';
  }

  function truncate(text, allowedLength) {
    if (text.length <= allowedLength) {
      return text;
    }

    return text.substring(0, allowedLength) + '...';
  }

  // see what formats are awailable for that layers WMS service (from GetCapabilities)
  function getDesiredFormatForWmsService(desiredFormats, availableFormats) {
    var formatToUse;
    var formatFound = false;
    // loop through desired formats and see if they are available
    desiredFormats.forEach(function(format) {
      if (formatFound) return;

      formatFound = availableFormats.indexOf(format) !== -1;
      if (formatFound) {
        formatToUse = format;
      }
    });

    return formatToUse || availableFormats[0];
  }

  function fetchAndSetAvailableFormats(options, wmsServiceUrls, wmsServiceConfigs) {
    if (!wmsServiceUrls) return;

    wmsServiceUrls.forEach(function(wmsServiceUrl) {
      performWmsRequest(getCapabilitiesUrl(options, wmsServiceUrl), function(response) {
        var xmlDoc = response.responseXML;
        if (!xmlDoc) {
          // service response did not return XML, but instead XML as a string (for example v 1.1.1)
          xmlDoc = convertStringToXmlDoc(response.responseText);
        }
        // get version
        var version;
        var firstNode =
          xmlDoc.getElementsByTagName('WMT_MS_Capabilities').length > 0
            ? xmlDoc.getElementsByTagName('WMT_MS_Capabilities')
            : xmlDoc.getElementsByTagName('WMS_Capabilities');
        if (firstNode.length > 0) {
          version = firstNode[0].getAttribute('version');
        }

        var capabilities = xmlDoc.getElementsByTagName('GetFeatureInfo');
        var availableFormats = capabilities.item(0).getElementsByTagName('Format');
        var formats = [];
        for (var i = 0; i < availableFormats.length; i++) {
          formats.push(availableFormats.item(i).innerHTML);
        }

        wmsServiceConfigs[wmsServiceUrl] = {
          formats: formats,
          version: version || options.version,
        };
      });
    });
  }

  function getUniqueWmsServiceUrls(layers) {
    if (!layers || !layers.length) return;

    var uniqueWmsServices = [];
    layers.forEach(function(layer) {
      var layerBaseUrl = stripQueryStrings(layer.wmslayer.baseurl);
      var hasAlreadyBeenAdded = uniqueWmsServices.indexOf(layerBaseUrl) > -1;
      if (!hasAlreadyBeenAdded) {
        uniqueWmsServices.push(layerBaseUrl);
      }
    });
    return uniqueWmsServices;
  }

  function getCapabilitiesUrl(options, wmsBaseUrl) {
    var urlParams = {
      service: 'WMS',
      request: 'GetCapabilities',
      version: options.version,
      format: 'text/xml',
    };
    return (
      options.proxyBaseUrl +
      stripQueryStrings(wmsBaseUrl) +
      L.Util.getParamString(urlParams, null, false)
    );
  }

  function getFeatureInfoUrl(options, request) {
    var boundingBox = request.map.getBounds();
    var mapSize = request.map.getSize();
    var wmsVersion = parseFloat(request.version);
    var crs = options.crs || request.map.options.crs;
    var projectionKey = wmsVersion >= 1.3 ? 'crs' : 'srs';
    var nw = crs.project(boundingBox.getNorthWest());
    var se = crs.project(boundingBox.getSouthEast());

    var urlParams = {
      service: 'WMS',
      request: 'GetFeatureInfo',
      version: request.version,
      format: 'image/png',
      width: mapSize.x,
      height: mapSize.y,
      info_format: request.format || 'application/json',
      layers: request.layerNames.join(','),
      query_layers: request.layerNames.join(','),
    };

    // different versions use different request prop names
    var isVersion1_3OrHigher = urlParams.version >= '1.3.0';
    urlParams[isVersion1_3OrHigher ? 'i' : 'x'] = request.x;
    urlParams[isVersion1_3OrHigher ? 'j' : 'y'] = request.y;
    urlParams[projectionKey] = crs.code;
    urlParams.bbox = (isVersion1_3OrHigher && crs === L.CRS.EPSG4326
      ? [se.y, nw.x, nw.y, se.x]
      : [nw.x, se.y, se.x, nw.y]
    ).join(',');

    return (
      options.proxyBaseUrl +
      stripQueryStrings(request.baseUrl) +
      L.Util.getParamString(urlParams, null, false)
    );
  }

  function performWmsRequest(url, callback) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        callback(this);
      }
    };
    xhttp.open('GET', url, true);
    xhttp.send();
  }

  function stripQueryStrings(url) {
    var queryStringIndex = url.indexOf('?');
    if (queryStringIndex === -1) return url;
    return url.substring(0, queryStringIndex);
  }

  function convertStringToXmlDoc(xmlString) {
    if (window.DOMParser) {
      return new window.DOMParser().parseFromString(xmlString, 'text/xml');
    } else if (
      typeof window.ActiveXObject != 'undefined' &&
      new window.ActiveXObject('Microsoft.XMLDOM')
    ) {
      var xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
      xmlDoc.async = 'false';
      xmlDoc.loadXML(xmlString);
      return xmlDoc;
    }

    return null;
  }
});

